import { render, staticRenderFns } from "./ProjectsModalDeletePdf.vue?vue&type=template&id=41ed4ce4&"
import script from "./ProjectsModalDeletePdf.vue?vue&type=script&lang=js&"
export * from "./ProjectsModalDeletePdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ed4ce4')) {
      api.createRecord('41ed4ce4', component.options)
    } else {
      api.reload('41ed4ce4', component.options)
    }
    module.hot.accept("./ProjectsModalDeletePdf.vue?vue&type=template&id=41ed4ce4&", function () {
      api.rerender('41ed4ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsModalDeletePdf.vue"
export default component.exports